export default "https://assets-v2.scaler.com/packs/images/refer-friend.24a30c.svg";